const removeButtonFromHTML = htmlString => {
  const buttonRegex = /<button[^>]*>.*?<\/button>/g;
  return htmlString.replace(buttonRegex, '');
};

const replaceContentBreakWithBr = htmlString => {
  const contentBreakRegex = /<div class="content-break"[^>]*>.*?<\/div>/g;
  return htmlString.replace(contentBreakRegex, '<br />');
};

const formatHTMLToCopy = htmlString => {
  if (!htmlString) return '';
  const html = removeButtonFromHTML(htmlString);
  const htmlWithContentBreak = replaceContentBreakWithBr(html);

  return htmlWithContentBreak;
};

export { removeButtonFromHTML, formatHTMLToCopy };
